import { Component } from '@angular/core';

@Component({
    selector: 'app-privacy-policy',
    standalone: false,
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {}
